// Author Liang Gang Qiang
// Date 2021-11-22 16:39:27

import * as model from "@/model/em/admin/ImfMstLocationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ImfMstLocation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'imfMstLocation',
        modelFilter: model.filter
    })
    .buildStore()
